import * as Fields from "#root/components/form/fields";
import StandardEditor from "#root/components/standard-editor";
import type { ReactNode } from "react";
import { useMemo } from "react";
import { createNewsRPMInstanceArticleSlugCollection } from "#root/schema/platform/newsrpm-instance";
import PageLayout from "./layout";

export default function ({ instanceId, slug }: { instanceId: string; slug: string }): ReactNode {
  const articleCollection = useMemo(() => createNewsRPMInstanceArticleSlugCollection(instanceId), [instanceId]);

  return (
    <PageLayout title="NewsRPM - Manage Article">
      <section>
        <h1>Edit Article</h1>
        <StandardEditor id={slug} collection={articleCollection}>
          <Fields.Set name="headline">
            <label>headline</label>
            <Fields.String/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="summary">
            <label>summary</label>
            <Fields.TextArea rows={5}/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="firstParagraph">
            <label>firstParagraph</label>
            <Fields.TextArea rows={5}/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="provider">
            <label>provider</label>
            <Fields.String/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="publisher">
            <label>publisher</label>
            <Fields.String/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="date">
            <label>date</label>
            <Fields.Timestamp/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="expires">
            <label>expires</label>
            <Fields.Timestamp/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="link">
            <label>link</label>
            <Fields.WebsiteURI/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="visiblity">
            <label>visiblity</label>
            <Fields.Select>
              <Fields.Option value="published">Published</Fields.Option>
              <Fields.Option value="retracted">Retracted</Fields.Option>
            </Fields.Select>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="metaData">
            <label>metaData</label>
            <Fields.JSONEditor rows={10}/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="normalizedData">
            <label>normalizedData</label>
            <Fields.JSONEditor rows={10}/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="sponsored">
            <label>sponsored</label>
            <Fields.BooleanSelect>
              <Fields.Option value={0}>False</Fields.Option>
              <Fields.Option value={1}>True</Fields.Option>
            </Fields.BooleanSelect>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="quality">
            <label>quality</label>
            <Fields.Integer/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="createdAt">
            <label>createdAt</label>
            <Fields.Timestamp/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="updatedAt">
            <label>updatedAt</label>
            <Fields.Timestamp/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="type">
            <label>type</label>
            <Fields.String/>
            <Fields.Validity/>
          </Fields.Set>
        </StandardEditor>
      </section>
    </PageLayout>
  );
}
